/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Cad_SuccessInputs */

const en_ticket_action_cad_success = /** @type {(inputs: Ticket_Action_Cad_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New date recorded.`)
};

const ja_ticket_action_cad_success = /** @type {(inputs: Ticket_Action_Cad_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい日付を記録しました。`)
};

const fr_ticket_action_cad_success = /** @type {(inputs: Ticket_Action_Cad_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle date enregistrée.`)
};

const de_ticket_action_cad_success = /** @type {(inputs: Ticket_Action_Cad_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Termin erfasst.`)
};

/**
* | output |
* | --- |
* | "New date recorded." |
*
* @param {Ticket_Action_Cad_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_cad_success = /** @type {((inputs?: Ticket_Action_Cad_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Cad_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_cad_success(inputs)
	if (locale === "ja") return ja_ticket_action_cad_success(inputs)
	if (locale === "fr") return fr_ticket_action_cad_success(inputs)
	return de_ticket_action_cad_success(inputs)
});